import React, { useMemo } from 'react';
import { Team } from '../types/user';
import { MinusCircleIcon, PlusCircleIcon } from '@heroicons/react/24/solid';

interface TeamBadgeProps {
  team: Team;
  className?: string;
  changed?: 'added' | 'removed' | 'none';
  truncateLength?: number;
}
const TeamBadge: React.FC<TeamBadgeProps> = ({ team, className = '', truncateLength = 15, changed='none' }) => {
  // Limit team name to 15 characters
  const displayName = team.name.length > truncateLength 
    ? `${team.name.substring(0, truncateLength)}...` 
    : team.name;

  const changedClass = useMemo(() => {
    return changed === 'added' ? 'bg-green-100 text-green-800' : changed === 'removed' ? 'bg-red-100 text-red-800' : 'bg-blue-100 text-blue-800'
  }, [changed]);

  const changedIcon = useMemo(() => {
    return changed === 'added' ? <PlusCircleIcon className="h-3 w-3 ml-1 text-green-900" aria-hidden="true" /> : changed === 'removed' ? <MinusCircleIcon className="h-3 w-3 ml-1 text-red-900" aria-hidden="true" /> : null;
  }, [changed]);
    
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${changedClass} ${className}`} title={team.name}>
      {displayName}
      {changedIcon}
    </span>
  );
};

export default TeamBadge;
